<template>
    <div class="" id="Video">
        <div class="bk-bg">
            <video width="100%" height="auto" controls poster="static/image/video-img.png">
                <source src="static/image/video.mp4"  type="video/mp4">
            </video>
        </div> 
    </div>
</template>

<script>
import {
    Swipe,
    SwipeItem,
    Indicator,
    Toast,
    Lazyload,
    InfiniteScroll,
    Header,
    Button,
    Field
} from "mint-ui";
import { API_GET, API_POST } from "@/apiConfig";
export default {
    name: "Video",
    data() {
        return {
            msg: "Welcome to Your Vue.js App",
            body: {
                identifier: "",
                code: "",
                type:"0"
            },
            count: 60,
            loading: false
        };
    },
    mounted() {},
    methods: {
        onLogin: function() {
            if (this.body.identifier && this.body.identifier.trim()) {
                this.loading = true;
                API_POST(
                    "https://user.lianlianche.com/welcome/login",
                    this.body,
                    true
                ).then(res => {
                    this.loading = false;
                    if (res.status == 0) {
                        window.localStorage.setItem("token", res.data.token);
                        window.localStorage.setItem("uid", res.data.uid);
                        // 登录时间设置为一个小时内有效
                        // window.localStorage.setItem("invalidDate",Date.now()+1000*60*60);
                        
                        Toast(`登录成功`);
                        window.history.back();
                    } else {
                        Toast(res.msg);
                    }
                });
            } else {
                Toast(`请填写正确的手机号码`);
                return;
            }
        },
        onGetCode: function() {
            /**
             * 发送验证码
             */
            if (this.body.identifier && this.body.identifier.trim()) {
                API_POST(
                    "https://user.lianlianche.com/welcome/sendMsg",
                    { phone: this.body.identifier },
                    true
                ).then(res => {
                    if (res.status == 0) {
                        let time = window.setInterval(() => {
                            this.count--;
                            if (this.count == 0) {
                                time = null;
                                this.count=60;
                            }
                        }, 1000);
                        Toast(`验证码已发送，请注意查收`);
                    } else {
                        Toast(res);
                    }
                });
            } else {
                Toast(`请填写正确的手机号码`);
                return;
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mintui-back {
    color: #2c2c2c;
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue